import { LuEye } from "react-icons/lu";

export function MaintenancePreviewRibbon() {
  return (
    <div role="status" className="mw-strip mw-ribbon d-flex align-items-center gap-3">
      <LuEye className="flex-shrink-0" aria-hidden="true" />
      <p className="flex-grow-1 mb-0 mw-min0">
        <b>Maintenance is live for customers.</b> You&apos;re seeing the app because you&apos;re a platform admin.
      </p>
    </div>
  );
}
